import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import { useAccount } from "PFCore/hooks/queries/accounts/use_account";
import React from "react";
import { useParams } from "react-router-dom";

import { FiltersAndOrderConfigPage } from "./filters_and_order_config_page";

export const FiltersAndOrderConfigController = () => {
  const { accountId } = useParams<{ accountId: string }>();

  const { data: account, isLoading: isAccountLoading } = useAccount({ accountId: Number(accountId) });

  const FiltersAndOrderConfigPageWrapped = usePageWrapper(FiltersAndOrderConfigPage);

  return <FiltersAndOrderConfigPageWrapped loading={isAccountLoading} account={account} />;
};
